import React, { useEffect, useState } from 'react';
import { Icon } from '@iconify/react';
import Section from '../Section';
import BlogSectionStyle2 from '../Section/BlogSection/BlogSectionStyle2';
import Breadcrumb from '../Breadcrumb';
import axios from 'axios';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL } from "../../helpers/api"; // ✅ add this
import "../../sass/shortcode/Blog.scss";

export default function Blog() {
  pageTitle('Blog');

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/blogs`)   // ✅ fixed
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : [];
        setBlogs(list);
      })
      .catch(err => {
        console.log("Blog Fetch Error:", err);
      });
  }, []);

  return (
    <>
      <section className="cs_blog_banner">
        <span className="cs_blog_dots cs_blog_dots_1" />
        <span className="cs_blog_dots cs_blog_dots_2" />
        <div className="container">
          <div className="cs_blog_banner_row">
            <div className="cs_blog_banner_left">
              <div className="cs_blog_icon">
                <span className="cs_blog_icon_circle">
                  <Icon icon="ph:pencil-simple" />
                </span>
              </div>
              <h1>Blog</h1>
              <span className="cs_blog_underline" />
              <p>
                Insights, updates, and stories to keep you informed about
                health and wellness.
              </p>
            </div>
            <div className="cs_blog_banner_right">
              <img
                src="/images/blog/blog_banner_illustration.png"
                alt="Blog"
                className="cs_blog_illustration"
              />
            </div>
          </div>
        </div>
      </section>

      <Section topMd={85} topLg={60} bottomMd={50} bottomLg={50} bottomXl={10}>
        <BlogSectionStyle2 data={blogs.map(b => ({ ...b, socialShare: false }))} />
      </Section>
    </>
  );
}
